import PropTypes from "prop-types";
import React from "react";
import Card from "react-md/lib/Cards/Card";
import { FontIcon } from "react-md";
import CardTitle from "react-md/lib/Cards/CardTitle";
import CardText from "react-md/lib/Cards/CardText";
import { QaRejections, QaRejectionsWithResponse } from "components/Homeowner/Appraisal";

function CaseHeaderTitle({ count }) {
  const issuesIconType = count === 0 ? "thumb_up" : "thumb_down";
  const description =
    count === 1
      ? "There is 1 unresolved QA Issue"
      : "There are " + (count === 0 ? "no" : count) + " unresolved QA Issues";

  return (
    <div>
      <FontIcon secondary inherit style={{ marginRight: "0.5em" }}>
        {issuesIconType}
      </FontIcon>
      {description}
    </div>
  );
}
CaseHeaderTitle.propTypes = { count: PropTypes.number };

const CaseRejections = (props) => {
  return (
    <Card className="md-cell md-cell--12"
      expanded={props.qaExpanded}
      onExpanderClick={props.expanderClicked}>
      <CardTitle
        expander
        onClick={() => props.expanderClicked(!props.qaExpanded)}
        style={{ cursor: "pointer" }}
        title={<CaseHeaderTitle count={props.unresolvedAppraiserRejectionCount} />} />
      <CardText
        expandable
      >
        <div>
          {
            props.viewOnly
              ? <QaRejections controlNumber={props.controlNumber} />
              : <QaRejectionsWithResponse controlNumber={props.controlNumber} />
          }
        </div>
      </CardText>
    </Card>
  );
};

CaseRejections.propTypes = {
  qaExpanded: PropTypes.bool, // Is the card expanded?
  expanderClicked: PropTypes.func, // Handle expansion of the card 
  controlNumber: PropTypes.number, // Control Number 
  unresolvedAppraiserRejectionCount: PropTypes.number, // Number of unresolved rejections
  viewOnly: PropTypes.bool, // List view only, or list with ability to respond to rejections
};

export default CaseRejections;

